import { getSafeApiUrl } from "./urlValidator";

/**
 * Resolves the vakotrade backend GraphQL URL from the iframe query
 * string. Preferred: `?exchange=<name>` (looked up in the per-exchange
 * map in `urlValidator.ts`). Legacy fallback: `?apiUrl=<url>` against
 * the same map's values, kept until every host app migrates.
 *
 * @returns the resolved URL, or null when nothing matches.
 */
export const getApiUrl = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return getSafeApiUrl(urlParams.get("exchange"), urlParams.get("apiUrl"));
};

/**
 * The Alfred REST endpoints live on the same backend as the GraphQL
 * API (`/psp/alfred/*`), so this is just an alias of `getApiUrl`.
 * Kept as a separate export so call-sites read clearly and so we can
 * point Alfred at a different host later without touching every file.
 */
export const getAlfredApiUrl = (): string => getApiUrl() ?? "";
